<template>
  <!-- 百才汇 要闻动态 常见问答详情页 -->
  <div class="wendacontent">
    <!-- 头部 -->
    <Header />
    <div class="wendacontentbox">
      <!-- banner -->
      <div class="bannerimgs">
        <img
          src="../../../assets/images/yaowendongtaiFile/changjianwenda/banner.png"
          alt="百才汇"
        />
      </div>
      <!-- 问答数据 -->
      <div
        class="wendaDatabox"
        v-for="(item, index) in wendacontentLIst"
        :key="index"
      >
        <!-- title -->
        <div class="titleimg">
          <img
            src="../../../assets/images/yaowendongtaiFile/changjianwenda/wendaxiangqing_icon.png"
            alt="百才汇"
          />
          <div>
            {{ item.Extend1 }}
          </div>
        </div>
        <div
          class="textcont"
          v-html="item.InfoHtmlBody ? item.InfoHtmlBody : ''"
        ></div>
        <!-- 表单 -->
        <div class="biaodanboxbk">
          <p class="title1">百才汇——专业、值得信赖的上海落户服务</p>
          <el-form label-width="0px" :model="wendaformLabelAlign">
            <el-form-item>
              <span class="icon">*</span>
              <el-input
                v-model="wendaformLabelAlign.name"
                placeholder="你的姓名"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <span class="icon">*</span>
              <el-input
                v-model="wendaformLabelAlign.phone"
                placeholder="请输入你的联系方式"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                type="textarea"
                placeholder="留言"
                v-model="wendaformLabelAlign.liuyan"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="button" @click="sbmitForm">立即预约</div>
        </div>
        <!-- 上一篇下一篇 -->
        <ul class="pageBox">
          <li @click="Proepages(prevData)">
            <p class="toptext">
              <!-- <van-icon name="arrow" /> -->
              上一篇<van-icon name="arrow" />
            </p>
            <div class="bottext">
              {{ prevData != null ? prevData.Extend1 : "无" }}
            </div>
          </li>
          <li @click="Nestpages(nextData)">
            <p class="toptext">下一篇<van-icon name="arrow" /></p>
            <div class="bottext">
              {{ nextData != null ? nextData.Extend1 : "无" }}
            </div>
          </li>
        </ul>
      </div>
      <!-- 相关推荐 -->
      <div class="tuiijanbk">
        <img
          class="tuijian_title"
          src="../../../assets/images/yaowendongtaiFile/changjianwenda/xiangguantuijian_title.png"
          alt="百才汇"
        />
        <ul class="tuijianOul">
          <li
            class="tuijianOli"
            v-for="(item, index) in tuijianLIst"
            :key="index"
            @click="clickTuijian(item)"
          >
            <div class="dian"></div>
            <div class="text">{{ item.Extend1 }}</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 底部 -->
    <Bottom />
  </div>
</template>

<script>
import Vue from "vue";
import { Notify } from "vant";
import Header from "@/P09_BaiCaiHui/components/Header.vue";
import Bottom from "@/P09_BaiCaiHui/components/Foot.vue";
export default {
  metaInfo() {
    return {
      title: this.tdktitle + "-百才汇",
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: "上海落户常见问题",
        },
        {
          hid: "description",
          name: "description",
          content: this.tdkdescription,
        },
      ],
    };
  },
  components: {
    Header,
    Bottom,
  },
  data() {
    return {
      //tdk
      tdktitle: "",
      tdkdescription: "",
      //初始化列表
      wendacontentLIst: [],
      pathUrl: "/wendacontent",
      currentPage: 1,
      total: 0,
      pageItemCount: 1,
      pageSize: 1,
      WebsiteMenuId: "",
      prevData: {}, //上一篇
      nextData: {}, //下一篇
      //form表单
      wendaformLabelAlign: {
        name: "",
        phone: "",
        liuyan: "",
      },
      //相关推荐列表
      tuijianLIst: [],
    };
  },
  activated() {},
  mounted() {
    // 初始化列表
    this.getData();
    //获取相关推荐
    this.tUiJianData();
  },
  methods: {
    //初始化列表
    getData() {
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          index: 1,
          size: 1,
          IsNeedPaging: 1,
          WebsiteContentId: this.$route.params.id,
          WebsiteMenuId: 330,
        })
        .then((res) => {
          this.wendacontentLIst = res.data.Data.list;
          this.total = res.data.DataCount;
          this.prevData = res.data.Data.PreviousPage;
          this.nextData = res.data.Data.NextPage;
          this.tdktitle = res.data.Data.list[0].Extend1;
          this.tdkdescription = res.data.Data.list[0].Extend2;
        });
    },
    //上一篇
    Proepages(item) {
      if (item != null) {
        this.toUrl(item);
        this.getData();
      } else {
        Notify({ type: "warning", message: "没有上一篇了哦" });
      }
    },
    //下一篇
    Nestpages(item) {
      if (item != null) {
        this.toUrl(item);
        this.getData();
      } else {
        Notify({ type: "warning", message: "没有下一篇了哦" });
      }
    },
    //id替换
    toUrl(item) {
      // if (item.InfoUrl === "/wendacontent") {
      this.$router.push(
        "/wendacontent/" +
          item.WebsiteContentId +
          "-" +
          item.WebsiteMenuId +
          ".html"
      );
      // } else {
      // window.location.href = item.InfoUrl;
      // }
    },
    //获取相关推荐
    tUiJianData() {
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          index: 1,
          size: 5,
          WebsiteMenuId: 329,
        })
        .then((res) => {
          this.tuijianLIst = res.data.Data.list;
        });
    },
    //点点击去相关推荐详情页
    clickTuijian(item) {
      this.$router.push("/luohuxiangqing/" + item.WebsiteContentId + ".html");
    },
    //form表单提交
    sbmitForm() {
      let _form = this.wendaformLabelAlign;
      if (!_form.name) {
        Notify({ type: "warning", message: "请输入姓名！" });
        return false;
      }
      if (!this.wendaformLabelAlign.phone) {
        Notify({ type: "warning", message: "请输入正确手机号码" });
        return false;
      }
      this.$axios
        .post("/trip/InfoSources/WebRegister", {
          C01_Name: _form.name, //姓名
          C01_Tel: _form.phone, //联系方式
          C01_Message: _form.liuyan, //留言
          C01_Origin: 193, //来源于那个官网
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.$message.success("提交成功！");
            this.wendaformLabelAlign.name = "";
            this.wendaformLabelAlign.phone = "";
            this.wendaformLabelAlign.liuyan = "";
          } else {
            this.$message.error(res.data.Message);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wendacontent {
  background: #f6f6f6;
  .wendacontentbox {
    margin-top: 80px;
    margin-bottom: 60px;
    // banner
    .bannerimgs {
      width: 100%;
      height: 200px;
      img {
        width: 100%;
        height: 200px;
      }
    }
    //问答数据
    .wendaDatabox {
      //title
      .titleimg {
        width: 670px;
        display: flex;
        margin: 60px auto 40px;
        img {
          width: 30px;
          height: 30px;
        }
        div {
          letter-spacing: 1px;
          font-size: 22px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          line-height: 33px;
          margin-left: 20px;
          margin-top: -4px;
        }
      }
      //textcont
      .textcont {
        width: 670px;
        margin: 0 auto;
        letter-spacing: 1px;
        /deep/img {
          width: 100%;
          height: 100%;
        }
      }
      //表单
      .biaodanboxbk {
        width: 564px;
        margin: 0 auto;
        background: url("../../../assets/images/yaowendongtaiFile/changjianwenda/formbk.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-top: 37px;
        padding-top: 36px;
        padding-bottom: 40px;
        .title1 {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #aa8756;
          letter-spacing: 1px;
          text-align: center;
        }
        /deep/.el-form {
          padding-top: 40px;
          width: 418px;
          margin: 0 auto;
          .el-form-item {
            margin-bottom: 39px;
            width: 100%;
            .icon {
              position: absolute;
              font-size: 14px;
              font-weight: bold;
              color: #ff0000;
              z-index: 1;
              top: 15px;
              left: 18px;
            }
            .el-input__suffix {
              top: 6px;
            }
            .el-form-item__error {
              left: 1.3rem;
            }
            .el-form-item__content {
              line-height: inherit;
              margin-left: 0 !important;
              .el-input__inner {
                padding-left: 30px;
                font-size: 14px;
                width: 100%;
                height: 58px;
                background: rgba(255, 255, 255, 0.17);
                border: 1px solid #eeeeee;
                border-radius: 10px;
                font-size: 18px;
              }
              .el-textarea__inner {
                padding-left: 32px;
                font-size: 14px;
                width: 100%;
                height: 92px;
                background: rgba(255, 255, 255, 0.17);
                border: 1px solid #eeeeee;
                border-radius: 10px;
                font-size: 18px;
              }
            }
          }
        }
        .button {
          width: 160px;
          background: #e8bc7e;
          border-radius: 20px;
          text-align: center;
          margin: 0 auto;
          cursor: pointer;
          letter-spacing: 1px;
          font-size: 22px;
          font-weight: bold;
          color: #ffffff;
          line-height: 40px;
          margin-top: 40px;
        }
      }
      //上一篇下一篇
      .pageBox {
        width: 670px;
        margin: 0 auto;
        background: #ffffff;
        display: flex;
        margin-top: 40px;
        li {
          width: 335px;
          padding: 23px;
          .toptext {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #6e6e6e;
            letter-spacing: 1px;
            i {
              vertical-align: middle;
              margin-left: 10px;
            }
          }
          .bottext {
            width: 286px;
            height: 58px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #6e6e6e;
            line-height: 30px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            letter-spacing: 1px;
            margin-top: 18px;
          }
        }
        li:first-child {
          border-right: 1px solid #eeeeee;
        }
        li:last-child {
          .toptext {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #e8bc7e;
            letter-spacing: 1px;
            i {
              vertical-align: middle;
              margin-left: 10px;
            }
          }
          .bottext {
            width: 286px;
            height: 58px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #e8bc7e;
            line-height: 30px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            letter-spacing: 1px;
            margin-top: 18px;
          }
        }
      }
    }
    //相关推荐
    .tuiijanbk {
      width: 670px;
      margin: 0 auto;
      background: #ffffff;
      padding: 50px 40px;
      margin-top: 60px;
      //title
      .tuijian_title {
        width: 110px;
        height: 24px;
        display: block;
      }
      .tuijianOul {
        .tuijianOli {
          display: flex;
          margin-top: 40px;
          .dian {
            width: 6px;
            height: 6px;
            background: #cbb486;
            margin-top: 8px;
          }
          .text {
            width: 570px;
            height: 26px;
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #555555;
            line-height: 28px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            letter-spacing: 1px;
            margin-left: 7px;
          }
        }
      }
    }
  }
}
</style>